import {withRouter} from "react-router-dom"
import {injectIntl} from "react-intl";
import Header from "../headers/HeaderUlaval2023/HeaderUlaval2023";
import Footer from "../footers/FooterUlaval2023/FooterUlaval2023";
import LoadEssentialDocuments from "../contents/Pages/DocumentsPage/LoadEssentialDocuments";

const DocumentsListLayout = () => {
    return (
        <>
            <Header/>
            <main role="main" property="mainContentOfPage" className="container main-content-container">
                <LoadEssentialDocuments />
            </main>

            <Footer/>
        </>
    );
}

export default withRouter(injectIntl(DocumentsListLayout));